import { defineComponent as _defineComponent } from 'vue'
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { ClearWorkforceForTeamPeriodDocument } from "owfsa-graphql";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { useMutation } from "@urql/vue";
import { ref } from "vue";
import { toast } from "vue-sonner";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClearWorkforce',
  setup(__props, { expose: __expose }) {
  __expose();

const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const clearWorkforceMutation = useMutation(ClearWorkforceForTeamPeriodDocument);

const showClearWorkforceDialog = ref(false);

async function clearWorkforce() {
  await clearWorkforceMutation.executeMutation({
    teamId: currSchedDataIdsStore.currTeamId,
    schedPeriodId: currSchedDataIdsStore.currSchedPeriodId,
  }).then(async (result) => {
    if (!result.error && !!result.data) {
      toast.success("Workforce settings have been cleared successfully");
      showClearWorkforceDialog.value = false;
    } else {
      toast.error("Error has occurred while clearing workforce settings");
    }
  });
}


const __returned__ = { currSchedDataIdsStore, clearWorkforceMutation, showClearWorkforceDialog, clearWorkforce, ConfirmationDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})